export default __webpack_public_path__ + "static/media/f2.03f3348e.png";